import { Navigate, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useAuthStore } from '@/stores/authStore'

export function RequireAuth({ children }) {
  const { t } = useTranslation()
  const ready = useAuthStore((s) => s.ready)
  const authenticated = useAuthStore((s) => s.authenticated)
  const location = useLocation()

  if (!ready) {
    return (
      <div className="flex min-h-[50vh] items-center justify-center text-muted-foreground">
        <span className="animate-pulse">{t('common.loading')}</span>
      </div>
    )
  }
  if (!authenticated) return <Navigate to="/welcome" state={{ from: location }} replace />
  return children
}
